import { SET_PLANS_REQUESTING, SET_PLANS } from '../actionTypes.constants'
import api from '../../utils/api'

export const plansRequesting = () => ({
  type: SET_PLANS_REQUESTING,
})

export const setPlans = (plans) => ({
  type: SET_PLANS,
  plans,
})

export const getPlans = () => async (dispatch, getState) => {
  try {
    const state = getState()
    const voucherCode = state.smartySharedData.voucherCode || ''
    const { data } = await api.get(`/plans?code=${voucherCode}`)
    dispatch(setPlans(data.data))
  } catch (error) {
    // Do nothing (UI will stay in loading state - agreed by team)
  }
}
